import { TypeInventory } from "@/lib/redux/features/flight/type"
import { formatOnlyAllowNumber } from "../app/formatOnlyAllowNumber"

type ParsedBaggage = {
  count: number
  weight: number
  rawText: string | null
}

const parseBaggage = (data: string | null | undefined): ParsedBaggage => {
  if (!data) {
    return { count: 1, weight: 0, rawText: null }
  }

  const lower = data.toLocaleLowerCase()
  const hasPieceFormat = lower.includes("kiện") || lower.includes("piece")

  if (hasPieceFormat) {
    const [count, weight] = lower.replace(/\s+/, "").split("x").map(str => formatOnlyAllowNumber(str))
    if (Number.isNaN(count) || Number.isNaN(weight)) {
      return { count: 1, weight: NaN, rawText: data }
    }
    return { count, weight, rawText: null }
  }

  const weight = formatOnlyAllowNumber(data)
  if (Number.isNaN(weight)) {
    return { count: 1, weight: NaN, rawText: data }
  }

  return { count: 1, weight, rawText: null }
}

export const formatBaggageLabel = (
  parsed: ParsedBaggage,
  pieceLabel: string,
) => {
  if (parsed.rawText) {
    return parsed.rawText
  }

  return `${parsed.count} ${pieceLabel} ${parsed.weight}kg`
}

export const getBaggageConditions = (flight: any, segment: any, inventoryOverride?: TypeInventory) => {
  const inventory: TypeInventory | undefined =
    inventoryOverride ||
    (flight as any)?.inventory ||
    flight?.inventories?.[0]

  const pickValue = (
    map?: Record<string, string> | null,
    segmentValue?: string | null,
  ) => {
    if (map) {
      const byNumber = segment?.flightNumber ? map[segment.flightNumber] : undefined
      if (byNumber) return byNumber
    }
    if (segmentValue) return segmentValue
    return map ? Object.values(map).find(Boolean) || null : null
  }

  const allowanceBaggageData = pickValue(
    inventory?.allowanceBaggage,
    segment?.allowanceBaggage,
  )
  const handBaggageData = pickValue(
    inventory?.handBaggage,
    segment?.handBaggage,
  )

  const allowanceParsed = parseBaggage(allowanceBaggageData)
  const handParsed = parseBaggage(handBaggageData)

  return {
    allowanceBaggageData,
    handBaggageData,
    allowanceBaggageCount: allowanceParsed.count,
    allowanceBaggage: allowanceParsed.weight,
    allowanceBaggageRaw: allowanceParsed.rawText,
    handBaggageCount: handParsed.count,
    handBaggage: handParsed.weight,
    handBaggageRaw: handParsed.rawText,
  }
}
